<div class="card">
  <head>
    <title>FAQ Page</title>
  </head>
  <body>
    <header>
      <div class="header-spacer"></div>

      <div class="header-title">Frequently Asked Questions</div>

      <div class="header-search">
        <div class="search-container">
          <input
            type="text"
            class="search-input"
            placeholder="Search FAQs..."
            [(ngModel)]="searchTerm"
            (input)="onSearchChange()"
            />
            @if (searchTerm.length === 0) {
              <i class="fa-solid fa-magnifying-glass icon"></i>
            }
            @if (searchTerm) {
              <button
                class="clear-search"
                (click)="clearSearch()"
                >
                ×
              </button>
            }
          </div>
        </div>
      </header>

      <main>
        @for (category of filteredFaqItems; track category) {
          <div class="faq-category">
            <h4 class="bold" [innerHTML]="category.category | highlight:searchTerm"></h4>
            @for (item of category.questions; track item) {
              <div class="faq-item">
                <div class="question" [innerHTML]="item.question | highlight:searchTerm"></div>
                <div class="answer" [innerHTML]="item.answer | highlight:searchTerm"></div>
              </div>
            }
          </div>
        }

        <!-- Show message when no results found -->
        @if (searchTerm && filteredFaqItems.length === 0) {
          <div class="no-results">
            <p>No FAQs found matching "{{ searchTerm }}"</p>
          </div>
        }
        <!-- <div class="faq-item">
        <h4 class="bold">Firearm Inventory Management</h4>
        <span class="question">How do I add a firearm to my bound book?</span>
        <p class="answer">
          You have two options to add items to your bound book.
          <li>
            <span class="bold">Option 1:</span> For adding a single item, go to
            Acquisitions > Acquisition
          </li>
          <li>
            <span class="bold">Option 2:</span> For adding multiple items there
            is a bulk option. Go to Acquisitions > Bulk Acquisitions
          </li>
          To add a firearm to inventory, go to Inventory > Add Firearm. You'll
          need the serial number, manufacturer, model, and caliber. For
          transfers, use the Disposition Builder to create a 4473 form.
        </p>
        <span class="question">How do I add a firearm to my bound book?</span>
        <p class="answer">
          You have two options to add items to your bound book.
          <li>
            <span class="bold">Option 1:</span> For adding a single item, go to
            Acquisitions > Acquisition
          </li>
          <li>
            <span class="bold">Option 2:</span> For adding multiple items there
            is a bulk option. Go to Acquisitions > Bulk Acquisitions
          </li>
          To add a firearm to inventory, go to Inventory > Add Firearm. You'll
          need the serial number, manufacturer, model, and caliber. For
          transfers, use the Disposition Builder to create a 4473 form.
        </p>
      </div>
      <div class="faq-item">
        <h4 class="bold">4473 Form and Background Checks</h4>
        <ul class="questions">
          <li>How do I complete a 4473 form?</li>
        </ul>
        <p class="answer">
          The 4473 form is completed through our Disposition Builder. Select the
          firearm, choose the buyer, fill out their information, and submit for
          NICS background check. The system will guide you through each step.
        </p>
      </div>
      <div class="faq-item">
        <h4 class="bold">Inventory Management</h4>
        <ul class="questions">
          <li>How do I check inventory levels?</li>
        </ul>
        <p class="answer">
          View all inventory in the Inventory section. You can filter by type,
          manufacturer, or availability. To update stock counts, edit the item
          and adjust the quantity field.
        </p>
      </div>
      <div class="faq-item">
        <h4 class="bold">Sales and Receipts</h4>

        <li>How do I create a sales receipt?</li>

        <p class="answer">
          Create sales receipts in the Sales section. Add customer information,
          select items, and set quantities. Receipts can be edited before
          finalizing, but may require admin approval after completion.
        </p>
      </div>
      <div class="faq-item">
        <h4 class="bold">Bound Book and ATF Records</h4>
        <ul class="questions">
          <li>What is a bound book?</li>
        </ul>
        <p class="answer">
          The bound book tracks all firearm acquisitions and dispositions as
          required by ATF. Entries are automatically created when you add
          inventory or complete transfers. You can view and print reports in the
          Bound Book section.
        </p>
      </div> -->
    </main>
    <footer>
      <p>© 2025 FAQ Resource Center</p>
    </footer>
  </body>
</div>
